import React from 'react';

import PropTypes from 'prop-types';
import { chekIsSpentAcc, getProgressBarColor } from 'utils/accumulators';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const KBYTE_PERCENT_BASE = 1048576;

const getProgresBarInfo = (acc, progressBarLimits) => {
  const accCopy = { ...acc };

  // SIM-258
  if (accCopy.unit === 'KBYTE') {
    accCopy.size = KBYTE_PERCENT_BASE;
  }

  const { size, rest, isUnlimited } = accCopy;

  const restPercent = rest / size * 100;

  if (isUnlimited || restPercent > 100) {
    return [100, 'green'];
  }

  return [restPercent, getProgressBarColor(accCopy, progressBarLimits)];
};

const getAccWithFixedSize = (acc, fixedAccSizes) => ({
  ...acc,
  size: fixedAccSizes[acc.unit.toLowerCase()] ?? acc.size,
});

const AccumulatorProgressBar = ({ acc, progressBarLimits, className, fixedAccSizes }) => {
  const newAcc = getAccWithFixedSize(acc, fixedAccSizes);
  const [valueRestPercent, progressBarColor] = getProgresBarInfo(newAcc, progressBarLimits);
  const isSpent = chekIsSpentAcc(acc);

  return (
    <div className={cx('progressBar', { disabled: isSpent }, className)}>
      <div className={cx('progressBarValue')} style={{ width: `${valueRestPercent}%` }}>
        <div
          className={cx('progressBarFill', progressBarColor)}
        />
      </div>
    </div>
  );
};

AccumulatorProgressBar.propTypes = {
  acc: PropTypes.shape({
    size: PropTypes.number,
    rest: PropTypes.number,
    isUnlimited: PropTypes.bool,
  }),
  progressBarLimits: PropTypes.objectOf(PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  })),
  fixedAccSizes: PropTypes.objectOf(PropTypes.number),
};

export default AccumulatorProgressBar;
